export function selectInitialTrip({ tripIdParam, trips, defaultTrip }) {
  if (tripIdParam) {
    const requestedTrip = trips.find(
      (trip) => String(trip.id) === String(tripIdParam),
    );
    return requestedTrip || null;
  }

  return defaultTrip || trips[0] || null;
}
